<div class="isav-map-popup" #popup>
    <div class="isav-map-popup__content">
        <ng-container *ngFor="let feature of popupFeatures">
            <ng-template [cdkPortalOutlet]="feature"></ng-template>
        </ng-container>
    </div>
</div>
